/**
 * Inline MSW responses for the Klaviyo list-sync endpoints (ENG-5524). Kept in a sibling file
 * and spread into the ENV-wide map in `inlineResponses.tsx` to stay under the file-length limit.
 *
 * `get-lists` returns a couple of sample lists so the picker renders; `sync-companies-to-list`
 * returns a plausible summary. The live backend talks to the real Klaviyo API.
 */
export const KLAVIYO_INLINE_RESPONSES: Record<
  string,
  Record<string, unknown> | unknown[]
> = {
  "/apollo/klaviyo/get-lists": [
    { id: "Wp3abc", name: "Daily + Weekly Shippers" },
    { id: "Xy9def", name: "Newsletter Subscribers" },
  ],
  "/apollo/klaviyo/sync-companies-to-list": {
    listId: "Wp3abc",
    listName: "Daily + Weekly Shippers",
    companiesProcessed: 3,
    contactsQueued: 4,
    companiesSkippedUnverified: 0,
    companiesSkippedDead: 0,
    contactsSkippedNoEmail: 1,
  },
};
